export default __webpack_public_path__ + "media/images/icons_fc/sale-e79dd84f264b2c33b970433200caa671.png";